import React from "react";
import { Skeleton } from "antd";
import { SkeletonCardProps } from "@companion-core/shared/app/Components/Cards/SkeletonCard/SkeletonCard.model";
import "Assets/Styles/scss/skeletonCard.scss";

export const SkeletonCard = ({ imageOnly = false }: SkeletonCardProps) => {
  return (
    <div
      data-testid="skeleton-card"
      className={`skeleton-card ${imageOnly ? "skeleton-card--image-only" : ""}`}>
      <Skeleton.Image data-testid="skeleton-card__image" active />
      <div data-testid="skeleton-card__content" className="skeleton-card__content">
        <Skeleton.Input
          data-testid="skeleton-card__title"
          className="skeleton-card__title"
          active
        />
        <Skeleton.Input
          data-testid="skeleton-card__subtitle"
          className="skeleton-card__subtitle"
          active
        />
      </div>
    </div>
  );
};
